const terceroEnumerators = {
  tipo: ['Cliente', 'Contratista', 'Proveedor', 'Fabricante', 'Gestor de Reciclaje', 'Representante de Marca'],
};

export default terceroEnumerators;
